import { createSlice } from '@reduxjs/toolkit';
import {
  acceptClientAppointmentRequestBuilder,
  acceptClientDeleteRequestBuilder,
  acceptClientPaymentRequestBuilder,
  acceptClientRequestBuilder,
  fetchNumOfUnReadNotificationsBuilder,
  getAllNotificationsBuilder,
  markNotificationsAsSeenBuilder,
  rejectClientAppointmentRequestBuilder,
  rejectClientRequestBuilder,
  rejectContractDeleteRequestBuilder,
  rejectPaymentForClientRequestBuilder,
} from './builder';

const initialState = {
  markNotificationsAsSeenPending: false,
  getAllNotificationsPending: false,
  rejectClientRequestPending: false,
  acceptClientRequestPending: false,

  numOfUnreadNotifications: 0,

  notifications: {
    data: [],
    maxReached: false,
    page: 1,
    total: 0,
    perPage: 0,
  },
};
export const notificationSlice = createSlice({
  name: 'notificationInfo',
  initialState,

  reducers: {},
  extraReducers: builder => {
    getAllNotificationsBuilder(builder);
    fetchNumOfUnReadNotificationsBuilder(builder);
    markNotificationsAsSeenBuilder(builder);
    acceptClientRequestBuilder(builder);
    rejectClientRequestBuilder(builder);
    acceptClientPaymentRequestBuilder(builder);
    acceptClientAppointmentRequestBuilder(builder);
    rejectPaymentForClientRequestBuilder(builder);
    rejectClientAppointmentRequestBuilder(builder);
    acceptClientDeleteRequestBuilder(builder);
    rejectContractDeleteRequestBuilder(builder);
    builder.addCase('logout', () => initialState);
  },
});

export const {} = notificationSlice.actions;

export const selectNotifications = state => state.notificationInfo.notifications;
export const selectGetAllNotificationsPending = state => state.notificationInfo.getAllNotificationsPending;
export const selectNumOfUnreadNotifications = state => state.notificationInfo.numOfUnreadNotifications;
export const selectRejectClientRequestPending = state => state.notificationInfo.rejectClientRequestPending;
export const selectAcceptClientRequestPending = state => state.notificationInfo.acceptClientRequestPending;

export default notificationSlice.reducer;
